import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

// Returns the stored Audit (same shape as getTailoredAudits items) so callers can update their
// display immediately instead of waiting for the invalidation-driven refetch (FIQ-682)
export const updateTailoredAuditReason = api(function updateTailoredAuditReason(auditId, reason) {
    return mutate(
        gql`
            mutation UpdateTailoredAuditReason($auditId: String!, $reason: String!) {
                updateTailoredAuditReason(auditId: $auditId, reason: $reason) {
                    id
                    shortDescription
                    longDescription
                    referenceId
                    type
                    date
                    userId
                    userName
                    payload
                }
            }
        `,
        { auditId, reason },
        { returns: "updateTailoredAuditReason" }
    )
})
